import { isPlatform } from '@ionic/react';

type ActionType = 'hover' | 'focus' | 'click' | 'contextMenu';

export const tooltipTrigger: ActionType = isPlatform('desktop')
  ? 'hover'
  : 'focus';
